import { Improvements } from '@aloft/toolkit-shared';

import {
  CompPropertyDataState,
  PropertyDataState,
  SubjectPropertyDataState,
} from '../../../types.ts';

export const getCurrentImprovements = (current: PropertyDataState): Improvements => {
  const { id } = current;
  const isSubject = id === 'subject';

  const propertyData = isSubject
    ? (current as SubjectPropertyDataState).subjectData
    : (current as CompPropertyDataState).compData;

  return propertyData.editableData.improvements;
};
